<template lang="pug">
.popup(v-if="isOpened" :class="getClass" @click.self="handleClose")
  .popup__wrap
    .popup__close(v-if="!isInnerControls" @click="handleClose")
      ControllerClose( :theme="theme")
    .popup__arrows(v-if="isShowArrow")
      Arrows(:theme="theme", @changePrev="handlePrev", @changeNext="handleNext")
    .popup__container
      .popup__close(v-if="isInnerControls" @click="handleClose")
        ControllerClose(:theme="theme")
      slot
</template>
<script>
import ControllerClose from "../../controllers/vue/ControllerClose.vue";
import Arrows from "../../controllers/vue/Arrows.vue";

export default {
  name: "PopupDefault",
  components: {
    ControllerClose,
    Arrows,
  },
  props: {
    isOpened: {
      type: Boolean,
    },
    isShowArrow: {
      type: Boolean,
      default: false,
    },
    isInnerControls: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "white",
    },
  },
  computed: {
    getClass() {
      return {
        "popup--inner-controls": this.isInnerControls,
      }
    },
  },
  watch: {
    isOpened() {
      if (this.isOpened) {
        document.querySelector("body").classList.add("body-overflow");
      } else {
        document.querySelector("body").classList.remove("body-overflow");
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    handleKeyDown(e) {
      const key = e.key;

      if (this.isOpened && key === "Escape") {
        this.handleClose();
      }
      if (key === "ArrowLeft") {
        this.handlePrev();
      }
      if (key === "ArrowRight") {
        this.handleNext();
      }
    },
    handleClose() {
      this.$emit("closePopup");
    },
    handlePrev() {
      this.$emit("showPrev");
    },
    handleNext() {
      this.$emit("showNext");
    },
  },
};
</script>
<style lang="scss">
@import "../style/popup";
</style>
